import * as React from 'react';
//import {Input, Table, Grid, Dropdown, Menu} from 'semantic-ui-react';
import {Input, Modal, Table} from 'semantic-ui-react';
import LogisticsService from "../../services/LogisticsService";
import LoadingContainer from "../../containers/LoadingContainer/LoadingContainer";
import InfiniteScroll from 'react-infinite-scroller';

import i18n from "../../../../locale/i18n";
import LoadingSpinner from "../../containers/LoadingContainer/LoadingSpinner";
import authService from "../../services/AuthService";
import Button from "semantic-ui-react/dist/commonjs/elements/Button/Button";
import {GUARD_LOGISTICSPLUS_OR_ADMIN} from "../../routes";

const translator = i18n.t.bind(i18n);

interface InventoryAccountModalProps {
    chooseFunc: Function
}

interface InventoryAccountModalState {
    open: boolean,
    loading: Boolean,
    data: any,
    page: number,
    filter: string,
    sortColumn: string,
    sortDirection: "ascending" | "descending"
}

class InventoryAccountModal extends React.Component<InventoryAccountModalProps, InventoryAccountModalState> {

    isLoading: Boolean = false;

    constructor(props: InventoryAccountModalProps) {
        super(props);

        this.state = {
            open: false,
            loading: true,
            data: null,
            page: 0,
            filter: "",
            sortColumn: "kontoNr",
            sortDirection: "ascending"
        };

        this.handleSortChange = this.handleSortChange.bind(this);
        this.handleInfinityScroll = this.handleInfinityScroll.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
    }

    reloadData() {
        LogisticsService.getAllAccounts(this.state.sortColumn, this.state.sortDirection === "ascending" ? "ASC" : "DESC", 0, 100, this.state.filter).then(
            (data) => {


                if (data.data.filter.toUpperCase() !== this.state.filter.toUpperCase()) {
                    return;
                }

                let stateData = data.data.page;

                this.setState(
                    {
                        data: stateData,
                        page: 0,
                        loading: false
                    }
                );

            }
        );

    }

    loadData() {
        let instance = this;

        let pageToLoad = this.state.page +1;
        let count = this.state.data.size;

        LogisticsService.getAllAccounts(
            this.state.sortColumn,
            this.state.sortDirection === "ascending" ? "ASC" : "DESC",
            pageToLoad, count, this.state.filter
        ).then(
            function(data) {

                let newData = instance.state.data;

                newData.content = newData.content.concat(data.data.page.content);

                instance.setState( {
                    data: newData,
                    page: data.data.page.number,
                }, () => { instance.isLoading = false;});


            }
        );
    }

    handleFilterChange(event: any) {
        this.setState({filter: event.target.value}, this.reloadData);
    }

    handleInfinityScroll() {
        if (!this.isLoading) {
            this.isLoading = true;
            this.loadData();
        }
    }

    handleSortChange(column: string) {
        if (this.state.sortColumn === column) {
            this.setState({sortDirection: (this.state.sortDirection === "ascending" ? "descending" : "ascending")}, this.reloadData);
        } else {
            this.setState({sortColumn: column, sortDirection: "ascending"}, this.reloadData);
        }
    }

    componentDidMount() {

        this.reloadData();
    }


    render() {

        let totalElements = 0;

        let Rows = null;

        if (this.state.data != null) {

            totalElements = this.state.data.totalElements;

            Rows = this.state.data.content.map((dataRow: any) => {
                return (
                    <Table.Row>
                        <Table.Cell style={{cursor: "pointer"}} onClick={ ()=>{ this.setState({open: false}); this.props.chooseFunc(dataRow.kontoNr);}} >{dataRow.kontoNr}</Table.Cell>
                    </Table.Row>
                );
            });
        }


        let conditionalContent = this.state.loading ? (
            <LoadingContainer showLogo={false}/>
        ) : (
            <>

                <p>{translator("Inventory.Found$dAccounts", {count: totalElements})}</p>
                <Input icon={'search'} placeholder={translator("Forms.Placeholder.Search")} type={"text"} onChange={this.handleFilterChange} value={this.state.filter}/>

                <Table celled striped sortable >
                    <Table.Header id={"tableHeader"}>
                        <Table.Row>
                            <Table.HeaderCell singleLine
                                              sorted={this.state.sortColumn === 'kontoNr' ? this.state.sortDirection : undefined}
                                              onClick={this.handleSortChange.bind(this,'kontoNr')}
                            >{translator("Inventory.Account")}</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <InfiniteScroll
                        pageStart={0}
                        loadMore={this.handleInfinityScroll}
                        hasMore={this.state.data.totalPages > this.state.page}
                        threshold={500}
                        useWindow={false}
                        element={'tbody'}
                        style={{height: "50vh"}}
                    >
                        {Rows}
                    </InfiniteScroll>
                </Table>
                {this.isLoading && <div style={{textAlign:'center', height:'3em'}}><LoadingSpinner /></div>}
            </>);

        if (!GUARD_LOGISTICSPLUS_OR_ADMIN() && authService.principal.accounts.length > 1) {
            //create the account-overview button and view.
            return(
                <Modal open={this.state.open} trigger={<Button onClick={()=>{this.setState({open: true})}}>{translator("Inventory.ChooseAccount")}</Button>}>
                    <Modal.Header>{translator("Inventory.ChooseAccount")}</Modal.Header>
                    <Modal.Content scrolling>
                        {conditionalContent}
                    </Modal.Content>
                    <Modal.Actions>
                        <Button default onClick={()=>{this.setState({open: false})}}>
                            {translator("Common.Cancel")}
                        </Button>
                    </Modal.Actions>
                </Modal>
            );
        }
        return (<></>);
    }
}

export default InventoryAccountModal;